<script lang="ts">
import type { PropType } from '@mimir/web/compat/vueCompat';
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VCol, VIcon, VRow, VTooltip } from 'vuetify/lib';

const isVue2 = !!import.meta.env.VUE_APP_V2;

export default defineComponent({
  name: 'InfoBubble',
  components: {
    VCol,
    VIcon,
    VRow,
    VTooltip,
  },
  props: {
    noGutters: {
      type: Boolean,
      default: false,
    },
    tooltipPosition: {
      type: String as PropType<'bottom' | 'top' | 'right' | 'left'>,
      default: 'bottom',
    },
  },
  data() {
    return {
      isVue2,
    };
  },
});
</script>

<template>
  <VRow
    :dense="!noGutters"
    :no-gutters="noGutters"
    class="flex-nowrap"
    align="baseline"
  >
    <VCol
      cols="auto"
      v-bind="$attrs"
    >
      <slot />
    </VCol>
    <VCol
      cols="auto"
      :class="noGutters ? 'ml-1' : undefined"
    >
      <VTooltip
        v-if="isVue2"
        :bottom="tooltipPosition === 'bottom'"
        :top="tooltipPosition === 'top'"
        :right="tooltipPosition === 'right'"
        :left="tooltipPosition === 'left'"
      >
        <template #activator="{ on }">
          <VIcon
            color="strong"
            small
            v-on="on"
          >info</VIcon>
        </template>
        <slot name="infotext" />
      </VTooltip>
      <VTooltip
        v-else
        :location="tooltipPosition"
      >
        <template #activator="{ props }">
          <span v-bind="props">
            <VIcon
              color="strong"
              small
            >info</VIcon>
          </span>
        </template>
        <slot name="infotext" />
      </VTooltip>
    </VCol>
    <slot name="append" />
  </VRow>
</template>
